import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Switch } from 'antd'

import { addAdmin, adminDetail, deletAdmin, getAdminList, reviseAdmin } from '_src/api/api'

const { confirm } = Modal
@Form.create({ name: 'AddAmin' })
class AddAmin extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.modelType = 0
    this.param = {
      status: '',
      pageNum: 0,
      totalElements: 0
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      loading: true,
      visible: false,
      dataList: [],
    }
  }

  componentDidMount () {
    this.loadData()
    getAdminList()
  }
  loadData () {
    this.setState(()=>({
      loading: true
    }))
    const { status, pageNum }= this.param
    getAdminList({status: status, pageSize: 10, pageNum: pageNum})
      .then(res=>{
        const { data } = res
        const { content, totalElements } = data
        this.param.totalElements = totalElements
        const dataList = content.map(item=>{
          return {...item, key: item.id}
        })
        this.setState({
          dataList: dataList,
          visible: false,
          loading: false
        })
      })
  }
  columns = () => {
    return [
      {
        title: <span>账号</span>,
        align: 'center',
        dataIndex: 'username',
        key: 'username',
      },
      {
        title: <span>真实姓名</span>,
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: <span>状态</span>,
        align: 'center',
        dataIndex: 'status',
        render: item => <div>{item === 1 ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>添加时间</span>,
        align: 'center',
        dataIndex: 'createAt',
        // render: item => <div>{item ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
          <Button icon="form" type='link' onClick={()=>{ this.onEdit(record) }} style = {{marginRight: 10}}>修改</Button>
          <Button icon="form" type='link' onClick={()=>{ this.onWatch(record) }} style = {{marginRight: 10}}>查看</Button>
          <Button icon="form" type='link' onClick={()=>{ this.onDelet(record) }} style = {{marginRight: 10, color: 'red'}}>删除</Button>
        </div>,
      },
    ]
  }


  handleCancel = () => this.setState({ previewVisible: false });
  onEdit (record) {
    this.modelType = 0
    this.setState(()=>({
      erroMsg: '',
    }))
    const { id } = record || ''
    this.id = id || ''
    this.upLoadFlage = !toString(this.id) // 重置更新状态
    this.setState({
      visible: true,
    }, ()=>{
      if (this.id) {
        adminDetail(this.id)
          .then(res=>{
            const { data } = res
            const { name, status, username } = data
            this.props.form.setFieldsValue({
              status: !!status,
              username,
              name,
            })
          })
      }
    })
  }

  onWatch (record) {
    this.modelType = 1
    const { id } = record
    this.id = id 
    this.setState({
      visible: true,
    }, ()=>{
      if (this.id) {
        adminDetail(this.id)
          .then(res=>{
            const { data } = res
            const { name, status, username, createAt } = data
            this.props.form.setFieldsValue({
              status: !!status,
              username,
              name,
              createAt
            })
          })
      }
    })
  }

  onDelet (record) {
    const { name, id } = record
    const _seft = this
    confirm({
      title: '温馨提示',
      content: `你确定要删除 ${name}`,
      onOk () {
        deletAdmin(id)
        _seft.loadData()
      },
      onCancel () {},
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.hide = message.loading(this.id?'管理员修改中':'管理员添加中', 0)
        // 需要更新图片
        let param = values
        let { status } = param
        status = !!status? 1 : 0
        param = {...param, status}
        this.handleReturnCause({...param})
        this.setState({
          erroMsg: ''
        })
      }
    })
  }


  // 保存专题
  handleReturnCause (param) {
    if (!this.id) {
      // 添加
      addAdmin(param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('添加成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          // this.loadData()
          message.error('添加失败', 1.5)
        })
    }
    else {
      // 修改
      reviseAdmin(this.id, param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('修改成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          message.error('修改失败', 1.5, ()=>{
            this.loadData()
          })
        })
    }
  }

  handleEditCancel = () => {
    this.setState({ visible: false })
  }
  // handleSearch = (e) => {
  //   this.param.status = e.target.value
  //   this.param.pageNum = 0
  //   this.loadData()
  // }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, visible, loading } = this.state
    const { getFieldDecorator } = this.props.form

    return (
      <div className = "page_content">
        <div className = "simple_top">
          <Button type = "primary" onClick = { () => { this.onEdit() } }>添加</Button>
          {/* <Radio.Group defaultValue="" buttonStyle="solid" className = 'searchSelect'
            onChange = { this.handleSearch }
          >
            <Radio.Button value="">全部</Radio.Button>
            <Radio.Button value={1}>显示状态</Radio.Button>
            <Radio.Button value={0}>禁用状态</Radio.Button>
          </Radio.Group> */}
        </div>
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (this.param.pageNum + 1),
            total: this.param.totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Modal
          title={ '管理员设置'}
          width={600}
          visible={visible}
          onCancel={this.handleEditCancel}
          footer={false}
          destroyOnClose // 关闭时候销毁
        >
          <Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}>
            <Form.Item label="是否启用">
              {getFieldDecorator('status', { valuePropName: 'checked' })(
                <Switch disabled = {!!this.modelType} />
              )}
            </Form.Item>
            <Form.Item label="账户" number>
              {getFieldDecorator('username', { rules: [{ required: true, message: '账号不能为空', }] })(
                <Input disabled = {!!this.modelType} placeholder="请输入账号" />)}
            </Form.Item>
            <Form.Item label="真实姓名" number>
              {getFieldDecorator('name', { rules: [{ required: true, message: '真实姓名不能为空', }] })(
                <Input disabled = {!!this.modelType} placeholder="请输入真实姓名" />)}
            </Form.Item>
            {
              !!this.modelType
                ?<Form.Item label="创建时间" number>
                  {getFieldDecorator('createAt', { rules: [{ required: true, message: '', }] })(
                    <Input disabled = {!!this.modelType} placeholder="" />)}
                </Form.Item>
                :<Form.Item label="密码" number>
                  {getFieldDecorator('password', { rules: [{ required: true, message: '密码不能为空', }] })(
                    <Input disabled = {!!this.modelType} placeholder="请输入密码" />)}
                </Form.Item>
            }
            <Form.Item style={{ paddingLeft: 140 }}>
              <Button type="primary" htmlType="submit" icon='save' style={{ width: 248, float: 'left'}}>{!!this.modelType?'确定':'保存'}</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default AddAmin